module.exports = "./img/8d9246155d35dc8d802122926e71e488.png";